import ReceiptPrinterEncoder from '@point-of-sale/receipt-printer-encoder';

export class Printer {

    public ready: boolean = false;

    navigator: Navigator;

    knownDevices: USBDevice[] = [];

    public device: USBDevice|null = null;

    public onReady: Array<(printer: Printer) => void> = [];

    private initPromise: Promise<void> | null = null;

    constructor() {
        this.navigator = window.navigator;
    }

    async init(): Promise<void> {
        if (this.initPromise) return this.initPromise;

        this.initPromise = navigator.usb.getDevices().then(devices => {
            this.knownDevices = devices;

            if (devices.length > 0) {
                this.device = devices[0];
                return this.configureDevice(this.device)
                    .then(() => {
                        this.ready = true;
                    });
            }
        });

        return this.initPromise;
    }

    async requestDevice(): Promise<USBDevice> {
        return navigator.usb.requestDevice({
            filters: [],
        })
            .then(selectedDevice => {
                this.device = selectedDevice;
                console.log('requested' ,selectedDevice);

                return this.configureDevice(selectedDevice);
            })
            .then(() => {
                this.ready = true;
                return this.device;
            })
            .then((device) => {
                this.onReady.forEach(callback => callback(this));

                return device;
            })
            .catch(error => { console.log(error); return error; })
    }

    isReady(): boolean {
        return this.device !== null && this.ready;
    }

    isBrowserSupported(): boolean {
        return this.navigator.usb !== undefined;
    }

    hasAnyDevice(): boolean {
        return this.knownDevices.length > 0;
    }

    async configureDevice(device: USBDevice): Promise<void> {
        return await device.open()
            .then(() => device.selectConfiguration(1))
            .then(() => device.claimInterface(0))
    }

    async print(text: string): Promise<void> {
        const ioEndpoint = 2;

        if (!this.isBrowserSupported()) {
            console.log('Browser does not support USB');
            return;
        }

        console.log(this.device);

        let data = [];

        const encoder = new ReceiptPrinterEncoder({
            language: 'esc-pos'
        });

        data = encoder
            .codepage('cp852')
            .size('small')
            .text(text + "\n\n\n")
            .encode();

        this.device!.transferOut(ioEndpoint, data)
            .catch(error => { console.log(error); return error; })
    }

}
